module.exports = __webpack_public_path__ + "img/paytable_icon.b3bbf9da.svg";